module.exports = __webpack_public_path__ + "static/media/sally_full_logo.9a6c4f8d.svg";